import { render, staticRenderFns } from "./trust-badge.vue?vue&type=template&id=44634513&"
import script from "./trust-badge.vue?vue&type=script&lang=js&"
export * from "./trust-badge.vue?vue&type=script&lang=js&"
import style0 from "./trust-badge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports